/**
 * bodyClipPayload — distinguishes what a stored kind="body" animation asset's
 * bytes actually are.
 *
 * AAM stores/serves body assets as an opaque blob (see AvatarModel.jsx's
 * loadGlbCached): the normal case is a binary GLB, but a kimodo-generated
 * gesture registered via the kimodo repo's register_gestures.py uploads the raw
 * kimodo tracks JSON instead — there is no separate format column to branch on
 * server-side. A GLB always starts with the 4-byte 'glTF' binary magic; this
 * codebase never uploads a JSON-form glTF for kind="body" (always binary), so a
 * leading '{' unambiguously means tracks JSON, not a scene.
 */
export function isTracksJsonPayload(buf) {
  return !!buf && buf.byteLength > 0 && new Uint8Array(buf, 0, 1)[0] === 0x7b // '{'
}
